import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.vip.loaded,
    props.user.isAuth,
    (loaded, isAuth) => {
        return {
            loaded,
            isAuth
        }
    }
)